import React from 'react';

export interface IProps {
    children: any;
    title: string
}

const HanTab: React.FC<IProps> = ({ children, title }) => {
    return (
        <div className="han-tabs__tab-content">
            {children}
        </div>
    )
}

export default HanTab;
